import React from 'react';
import {Link} from 'react-router-dom';
import {Table} from 'semantic-ui-react';
import Loader from '../../../common/components/loader';

const DetailTable = ({combos, loading}) => {
  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <Table striped celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>LINEA</Table.HeaderCell>
          <Table.HeaderCell>FR</Table.HeaderCell>
          <Table.HeaderCell>CÓDIGO ARTÍCULO</Table.HeaderCell>
          <Table.HeaderCell>DESCRIPCIÓN ARTÍCULO</Table.HeaderCell>
          <Table.HeaderCell>CANTIDAD FACTURADA</Table.HeaderCell>
          <Table.HeaderCell>CÓDIGO COMBO</Table.HeaderCell>
          <Table.HeaderCell>DESCRIPCIÓN COMBO</Table.HeaderCell>
          <Table.HeaderCell>FACTURA</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {combos.map((combo, index) => (
          <Table.Row key={index}>
            <Table.Cell>{index + 1}</Table.Cell>
            <Table.Cell>{combo.franchise}</Table.Cell>
            <Table.Cell>{combo.partCode}</Table.Cell>
            <Table.Cell>{combo.name}</Table.Cell>
            <Table.Cell>{combo.quantity}</Table.Cell>
            <Table.Cell>{combo.codeCombo}</Table.Cell>
            <Table.Cell>{combo.description}</Table.Cell>
            <Table.Cell>
              <Link
                to='/facturacion-electronica'
                state={{...combo, 'type': combo.typeDocument}}
              >
                {combo.serial}-{combo.physicalNumber}
              </Link>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default DetailTable;
